import React from 'react';
import { EJRecordTypes } from 'src/common/enumerations/ej-record-types';
import { TenderType } from 'src/common/enumerations/tender-type';
import Cash from 'src/common/media/Cash.svg';
import DisabledCash from 'src/common/media/disabled-cash.svg';
import Check from 'src/common/media/Check.svg';
import DisabledCheck from 'src/common/media/disabled-check.svg';
import CouponGreenIcon from 'src/common/media/CouponGreenIcon.svg';
import CreditDebitGift from 'src/common/media/CreditDebit.svg';
import DisabledCreditDebitGift from 'src/common/media/disabled-credit-debit.svg';
import Ewic from 'src/common/media/Ewic.svg';
import DisabledEwic from 'src/common/media/disabled-ewic.svg';
import PromotionIcon from 'src/common/media/Promotions.svg';
import Reward from 'src/common/media/Reward.svg';
import DisabledReward from 'src/common/media/disabled-reward.svg';
import Voucher from 'src/common/media/VoucherTender.svg';
import { styles } from './tender-icon-styles';

export const TenderIcon: React.FC<TenderIconProps> = (props: TenderIconProps): JSX.Element => {
  const classes = styles();
  const tenderIconClass = props.isCustomerDisplay
    ? classes.tenderIconCustomerDisplay
    : classes.tenderIcon;
  switch (props.tenderType) {
    case EJRecordTypes.Coupon:
      return <img src={CouponGreenIcon} className={classes.coupon} alt='coupon-icon' />;
    case EJRecordTypes.Promotion:
      return <img src={PromotionIcon} className={classes.promotion} alt='promotion-icon' />;
    case EJRecordTypes.Reward:
    case EJRecordTypes.RewardAsTender:
      return props.disabled ? (
        <img src={DisabledReward} className={tenderIconClass} alt='disabled-reward-icon' />
      ) : (
        <img src={Reward} className={tenderIconClass} alt='reward-icon' />
      );
    case TenderType.Cash:
      return props.disabled ? (
        <img
          src={DisabledCash}
          data-testid='disabled-cash-icon'
          className={tenderIconClass}
          alt='disabled-cash-icon'
        />
      ) : (
        <img src={Cash} className={tenderIconClass} alt='cash-icon' />
      );
    case TenderType.CreditDebit:
      return props.disabled ? (
        <img
          src={DisabledCreditDebitGift}
          data-testid='disabled-debit-credit-icon'
          className={tenderIconClass}
          alt='disabled-creditdebit-icon'
        />
      ) : (
        <img src={CreditDebitGift} className={tenderIconClass} alt='creditdebit-icon' />
      );
    case TenderType.Check:
      return props.disabled ? (
        <img
          src={DisabledCheck}
          data-testid='disabled-check-icon'
          className={tenderIconClass}
          alt='disabled-check-icon'
        />
      ) : (
        <img src={Check} className={tenderIconClass} alt='check-icon' />
      );
    case TenderType.WicCvv:
    case TenderType.Ewic:
      return props.disabled ? (
        <img
          src={DisabledEwic}
          data-testid='disabled-ewic-icon'
          className={tenderIconClass}
          alt='disabled-ewic-icon'
        />
      ) : (
        <img src={Ewic} className={tenderIconClass} alt='ewic-icon' />
      );
    case TenderType.GiftCard:
      return props.disabled ? (
        <img
          src={DisabledCreditDebitGift}
          data-testid='disabled-gift-card-icon'
          className={tenderIconClass}
          alt='disabled-gift-card-icon'
        />
      ) : (
        <img src={CreditDebitGift} className={tenderIconClass} alt='gift-card-icon' />
      );
    case TenderType.Voucher:
      return <img src={Voucher} className={tenderIconClass} alt='voucher-icon' />;
    default:
      return <></>;
  }
};
interface TenderIconProps {
  tenderType: string;
  disabled?: boolean;
  isCustomerDisplay?: boolean;
}
